import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { FloatingLabelService1Service } from './services/floating-label-service1.service';
import { FloatingLabelService } from './services/floating-label.service';
import { HideFloatingLabelService } from './services/hide-floating-label.service';

@Directive({
  selector: '[idpAppFloatingLabel]',
  exportAs: 'FloatingLabelDirective'
})
export class FloatingLabelDirective implements AfterViewInit, OnChanges {
  @Input('idpAppFloatingLabel') labelvalue: string | undefined;
  @Input() placeholderValue: string | undefined;
  @Input() datavalue: string | undefined;
  @Input() isRequired = false;
  @Input() isOptional = false;
  @Input() isOptionalforPlaceholder = false;
  @Input() isRequiredforPlaceholder = false;
  @Input() useDataValue = false;
  private appPaymentsFloatingLabel: HTMLElement | null | undefined;
  private placeHolderLabel: string | undefined;
  private textLabel: unknown;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private ser1: FloatingLabelService1Service,
    private hideFloatingLabelService: HideFloatingLabelService,
    private floatingLabelService: FloatingLabelService
  ) {}

  @HostListener('focus') onFocused() {
    this.showFloatingLabel();
  }

  @HostListener('focusout') onFocusout() {
    this.hideFloatingLabel();
  }

  ngAfterViewInit() {
    const labelElement = this.elementRef.nativeElement.querySelector('label');
    if (labelElement) {
      this.renderer.setAttribute(
        labelElement,
        'data-cy',
        this.labelvalue || ''
      );
    }

    this.appPaymentsFloatingLabel = this.renderer.createElement('label');
    this.ser1.funOne(
      this.appPaymentsFloatingLabel,
      this.elementRef.nativeElement.id,
      this.renderer
    );
    this.ser1.funTwo(
      this.elementRef.nativeElement.placeholder,
      this.placeholderValue,
      this.placeHolderLabel,
      this.elementRef.nativeElement.placeholder,
      this.labelvalue
    );
    setTimeout(() => {
      this.hideFloatingLabel();
    }, 0);
    this.ser1.funFour(
      this.textLabel,
      this.labelvalue,
      this.isRequired,
      this.isOptional,
      this.appPaymentsFloatingLabel,
      this.elementRef.nativeElement,
      this.renderer
    );
    this.ser1.funFive(
      this.placeHolderLabel,
      this.isOptionalforPlaceholder,
      this.isRequiredforPlaceholder,
      this.placeholderValue,
      this.elementRef.nativeElement,
      this.renderer
    );
  }

  showFloatingLabel() {
    this.renderer.removeClass(this.appPaymentsFloatingLabel, 'invisible');
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'placeholder');
  }

  hideFloatingLabel() {
    const eleNativeValue = this.elementRef.nativeElement.value;
    const eleNative = this.elementRef.nativeElement;
    this.hideFloatingLabelService.floatingLabelfunOne(
      this.useDataValue,
      this.datavalue,
      this.appPaymentsFloatingLabel,
      eleNativeValue,
      this.placeHolderLabel,
      eleNative,
      this.labelvalue,
      this.renderer
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    this.floatingLabelService.new1FunctionCall(
      changes,
      this.appPaymentsFloatingLabel,
      this.textLabel,
      this.isRequired,
      this.isOptional,
      this.renderer
    );
    this.floatingLabelService.new2FunctionCall(
      changes,
      this.placeHolderLabel,
      this.placeholderValue,
      this.isRequiredforPlaceholder,
      this.isOptionalforPlaceholder,
      this.elementRef.nativeElement,
      this.renderer
    );
    this.floatingLabelService.new3FunctionCall(
      changes,
      this.appPaymentsFloatingLabel,
      this.elementRef.nativeElement,
      this.renderer
    );
    this.finalIfFun(changes);
  }

  finalIfFun(changes: SimpleChanges) {
    if (
      changes['datavalue'] &&
      this.useDataValue &&
      this.appPaymentsFloatingLabel
    ) {
      this.hideshowFloatingLable(changes);
    }
  }

  hideshowFloatingLable(changes: SimpleChanges) {
    if (changes['datavalue']['currentValue']) {
      this.showFloatingLabel();
    } else {
      this.hideFloatingLabel();
    }
  }
}
